<template>
    <div>
    <div class="fixed inset-0 z-10 bg-white overflow-hidden p-4">
        <!-- 1st row: settings -->
        <div class="flex flex-row-reverse w-full items-center">
            <a href="#" @click.prevent="toggleFullscreen">{{isFullscreen ? 'Exit Full Screen' : 'Full Screen'}}</a>
            <a href="/carry-freight/schedule-monitor/" class="flex items-center mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24">
                    <path class="heroicon-ui" d="M5.41 11H21a1 1 0 010 2H5.41l5.3 5.3a1 1 0 01-1.42 1.4l-7-7a1 1 0 010-1.4l7-7a1 1 0 011.42 1.4L5.4 11z"/>
                </svg>
                Exit Tv Mode
            </a>
            <div class="relative mr-4">
                <select v-model="dayRange" @change="handleDayRangeChange" class="block appearance-none w-full bg-gray-200 border pl-2 pr-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                    <option value="0">Last 24 Hours</option>
                    <option value="40">Forklift</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
            <span class="text-blue-300 text-sm mr-4">* To change the destinations shown, go to "My Settings" and change the branches selected</span>
        </div>
        <!-- 2nd row: table -->
        <div class="flex flex-row w-full">
            <table class="w-full table-fixed text-4xl font-bold">
                <thead>
                <tr>
                    <th class="px-4 py-2 text-center" style="width: 8%;">From</th>
                    <th class="px-4 py-2 text-center" style="width: 8%;">To</th>
                    <th class="px-4 py-2 text-center" style="width: 12%;">Truck</th>
                    <th class="px-4 py-2 text-center" style="width: 12%;">Departure</th>
                    <th class="px-4 py-2 text-center" style="width: 12%;">Arrival</th>
                    <th class="px-4 py-2 text-center" style="width: 20%;">Status</th>
                    <th class="px-4 py-2 text-center" style="width: 28%;">Location</th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="(journey, index) in journeys"
                        :key="index"
                >
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell">{{ journey.originPlace.name }}</div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell">{{ journey.destinationPlace.name }}</div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell">{{ journey.truckPlate }}</div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell">
                            <div>
                                {{getCalendarDate(journey.std)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(journey.std)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[journey.atdClass]">
                                {{getTime(journey.atd)}}
                            </div>
                        </div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell">
                            <div>
                                {{getCalendarDate(journey.sta)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(journey.sta)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[journey.etaOrAtaClass]">
                                {{getTime(journey.etaOrAta)}}
                            </div>
                        </div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden" :class="journey.statusClasses">
                        <div class="tv-cell">{{ journey.status }}</div>
                    </td>
                    <td class="border px-4 py-2 overflow-hidden">
                        <div class="tv-cell" v-if="journey.status.toLowerCase().includes('expected to') && journey.latestPoint">
                            <div style="max-height: 100px; overflow: auto">
                                {{journey.latestPoint.location.split(',')[0]}}
                            </div>
                            <div style="height: 50px;">
                                {{`${journey.latestPoint.speed} km/h`}} at {{journey.latestPoint.time.format("h:mma")}}
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!-- 3rd row: pagination bar-->
        <div class="fixed w-full flex flex-row justify-center" style="bottom: 1.5rem;">
            <el-pagination
                    background
                    layout="prev, pager, next, sizes, total, jumper"
                    :page-sizes="[1, 2, 3, 4, 5, 7, 10]"
                    :page-size="pagesize"
                    :total="truckRunningJourneys.length"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="currpage"
            >
            </el-pagination>
        </div>
    </div>
    <div v-if="isLoadingJourneys && truckRunningJourneys.length === 0" class="w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50">
      <span class="text-blue-300 opacity-75 top-1/2 my-0 mx-auto block relative w-0 h-0" style="top: 50%;">
        <i class="fas fa-circle-notch fa-spin fa-5x"/>
      </span>
    </div>
    </div>
</template>

<script>
    export default {
        // Do not forget this little guy
        name: 'SchedulesMonitorTvTw',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
        },
        // variables
        data() {
            return {
                dayRange: 0,
                isFullscreen: false,
                dayRanges: [
                    {
                        value: 0,
                        label: 'Default'
                    },
                    {
                        value: 50,
                        label: 'Forklift'
                    },
                ],
                momentNow: moment(),
                journeysUpdateTime: moment(),
                //pagination
                pagesize: 5,
                currpage: 1,
                stayTime: 10, //unit: second
                minimumReloadInterval: 5, //uni: minute
                looped: false,
            }
        },
        computed: {
            journeys () {
                return this.truckRunningJourneys.slice((this.currpage - 1) * this.pagesize, this.currpage * this.pagesize);
            },
            journeysUpdateTimeHuman () {
                return this.journeysUpdateTime.from(this.momentNow);
            },
            truckRunningJourneys () {
                return this.$store.getters.getTruckRunningJourneys;
            },
            isLoadingJourneys () {
                return this.$store.getters.getTruckRunningJourneysLoadStatus === 1;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
        },
        // when component uses other components
        components: {},
        // methods
        methods: {
            goto(url) {
                location.href = url;
            },
            reloadPage() {
                location.reload();
            },
            toggleFullscreen (event) {
                const elem = document.documentElement;
                if (
                    document.fullscreenEnabled ||
                    document.webkitFullscreenEnabled ||
                    document.mozFullScreenEnabled ||
                    document.msFullscreenEnabled
                ) {
                    if (!this.isFullscreen) {
                        if (elem.requestFullscreen) {
                            elem.requestFullscreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.webkitRequestFullscreen) {
                            elem.webkitRequestFullscreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.mozRequestFullScreen) {
                            elem.mozRequestFullScreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.msRequestFullscreen) {
                            elem.msRequestFullscreen();
                            this.isFullscreen = true;
                            return;
                        }
                    } else {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.msExitFullscreen) {
                            document.msExitFullscreen();
                            this.isFullscreen = false;
                            return;
                        }
                    }
                }
            },
            loadJourneys() {
                console.log('dispatch load journeys');
                const loadingJourneysMessage = this.$message({
                    message: 'Loading Journeys...',
                    center: true
                });
                this.$store.dispatch('loadTruckRunningJourneysTv', { modeCode: this.dayRange })
                    .then(() => {
                        this.journeysUpdateTime = moment();
                        if (typeof this.reloadInterval === 'undefined') {
                            //go to next page every 30 seconds
                            this.reloadInterval = setInterval(() => this.goNextPage(), this.stayTime * 1000);
                        }
                        if (typeof this.interval === 'undefined') {
                            //update moment now every 10 seconds
                            this.interval = setInterval(() => this.momentNow = moment(), 10000);
                        }
                    })
                    .catch(() => this.$message.error('Sorry, failed to load the journeys.'))
                    .then(() => {
                        loadingJourneysMessage.close();
                        this.looped = false;
                        this.currpage = 1;
                    });
            },
            getCalendarDate(time) {
                return time ? time.calendar(null, {
                    sameDay: '[]',
                    nextDay: '[Tomorrow]',
                    nextWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Next] dddd';
                    },
                    lastDay: '[Yesterday]',
                    lastWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Last] dddd';
                    },
                    sameElse: 'Do MMM'
                }) : null;
            },
            getTime(moment = null) {
                if (moment !== null) {
                    return moment.format("h:mma");
                }
                return null;
            },
            //pagination
            handleCurrentChange(cpage) {
                this.currpage = cpage;
            },
            handleSizeChange(psize) {
                this.pagesize = psize;
            },
            goNextPage() {
                console.log('goNextPage');
                if (this.truckRunningJourneys.length <= this.currpage * this.pagesize) {
                    this.currpage = 1;
                    if (moment().diff(this.journeysUpdateTime, 'seconds') >= 60 * this.minimumReloadInterval) {
                        this.loadJourneys();
                    }
                } else {
                    this.currpage++;
                }
            },
            handleDayRangeChange(event) {
                localStorage.dayRange = event.target.value;
                this.loadJourneys();
            }
        },
        // component Lifecycle hooks
        beforeDestroy() {
            clearInterval(this.interval);
            clearInterval(this.reloadInterval);
        },
        mounted() {
            if (localStorage.dayRange) {
                this.dayRange = localStorage.dayRange;
            }
/*            if (typeof this.reloadPageInterval === 'undefined') {
                //update moment now every 10 seconds
                this.reloadPageInterval = setInterval(() => this.reloadPage(), 30 * 60 * 1000);
            }*/
            this.loadJourneys();
        },
    };
</script>

<style scoped>
    .tv-cell {
        height: 160px;
        overflow: hidden;
        line-height: 50px;
        display: table-cell;
        vertical-align: middle;
    }

    >>> .text-eta {
        text-decoration: underline;
    }

    >>> .text-on-time {
        color: unset;
    }

    >>> .text-delay-yellow {
        color: #e6a23c;
    }

    >>> .text-delay-red {
        color: #f56c6c;
    }

    >>> .status-cell.on-time {
        background: #67C23A;
    }

    >>> .status-cell.delay-yellow {
        background: #E6A23C;
    }

    >>> .status-cell.delay-red {
        background: #F56C6C;
    }

    >>> svg {
        vertical-align: unset;
    }

    label {
        margin-bottom: 0;
    }

    .tv {
        padding: 10px 30px;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-color: white;
        z-index: 1;
    }
</style>